import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { SimpleGlobal } from 'ng2-simple-global';
import { ServiceprovidertypesService } from '../../_services/serviceprovidertypes/serviceprovidertypes.service';

@Component({
  selector: 'app-serviceprovidertypes',
  templateUrl: './serviceprovidertypes.component.html',
  styleUrls: ['./serviceprovidertypes.component.css'],
  providers:[ServiceprovidertypesService]
})
export class ServiceprovidertypesComponent implements OnInit {

  cookies: Object;
  serviceProviders:any;
  constructor(
       // private route: ActivatedRoute,
        private router: Router,
        private sg: SimpleGlobal,
        private ServiceprovidertypesService:ServiceprovidertypesService
      ) {
        this.cookies = Cookie.getAll();
        if(this.cookies['TokenKey'] == undefined){
         this.router.navigate(['']);
        }

        this.ServiceprovidertypesService.getServiceProviderType().subscribe(
          res => {
            this.serviceProviders = res;
          }
        );

       }

  ngOnInit() {
  }

    hideme:any = {};
  deleteservice(service){
    this.ServiceprovidertypesService.deleteservice(service.id).subscribe(
      res => {

      }
    );
    $("#status_" + service.id).text('Deleted');
    this.hideme[service.id] = true;
  }

}



// WEBPACK FOOTER //
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/serviceprovidertypes/serviceprovidertypes.component.ts